import { SellTagModelType, SellTagTypeKeys } from '@teinor/erp/types/company/order/sell/sellTag'
import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'
export interface SellTagsAction {
    type: 'CHANGE_SELL_TAGS'
    payload: SellTagModelType[]
}
export type SellTagTypesPayload = SellTagModelType[]
export interface SellTagsParsed {
    allTags: { [id: number]: SellTagModelType } | null
    sell: { [id: number]: SellTagModelType } | null
}
export type SellTagJson = { [id: number]: SellTagModelType } | null
type ReduxSellTagTypes = 'sell' | 'allTags'
export type SellTagsPayload = SellTagsParsed | null
export default function sellTags(state: SellTagsPayload = null, action: SellTagsAction): SellTagsParsed | null {
    switch (action.type) {
        case 'CHANGE_SELL_TAGS':
            const tagsTypesDict: Record<SellTagTypeKeys, ReduxSellTagTypes> = {
                0: 'allTags',
                1: 'sell',
            }
            const result: SellTagsParsed = {
                allTags: {},
                sell: {},
            }
            result.allTags = dictionaryComplexFromJsonArr(action.payload)
            for (const key in action.payload) {
                const tag = action.payload[key]
                const myType = tagsTypesDict[tag.type!]
                if (!result[myType]) {
                    result[myType] = {}
                }
                result[myType]![tag.id] = tag
            }
            return state = result
        default:
            return state
    }
}